export default {
	all: 'All',
	favorite: 'Favorite',

	'edit-fav-list': 'Edit fav list',

	'total-without-vat': 'Total without vat',
	'total-net': 'Total net',
	paid: 'Paid',
	unpaid: 'unpaid',
	alert: 'Alert',
	'alert-message': 'Prices will be changed to the prices allocated for this account, if any',
	'search-products': 'Search for products',
	'main-items': 'Main items',
	'invoice-details': 'Invoice Details',
	extra: 'Extra',
	'all-favorites': 'All Favorites',
	'did-not-add-any-items-yet': 'There are no required items yet.',
	'choose-item-to-add': 'Choose an item to add with the ability to adjust the quantity.'
}